import api from '@/api';
import { API_BASE_URL } from '../../index';
import { QuestReportOsXFinancialRequest } from './OsXFinancial.types';

const CONTROLLER_URL = `${API_BASE_URL}/Reports`;

export async function getQuestReportOsXFinancial(
  params: QuestReportOsXFinancialRequest,
) {
  const result = (await api.getReport(
    `${CONTROLLER_URL}/OsXFinancial`,
    params,
  )) as unknown;

  return result as BlobPart;
}
